import { render, staticRenderFns } from "./Data-Table-Generic-Placeholder.vue?vue&type=template&id=5b3047fd&lang=pug"
import script from "./Data-Table-Generic-Placeholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./Data-Table-Generic-Placeholder.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports